import { useTranslation } from 'react-i18next';
import Globe from '../../assets/img/icon/globe.png';
import "../../index.css";
import styles from './languageSwitcher.module.css';
import { Dropdown } from 'react-bootstrap';

export const LanguageSwitcher = ({ onClick }) => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'ar', name: 'العربية', flag: '🇸🇦' },
    { code: 'tr', name: 'Türkçe', flag: '🇹🇷' }
  ];

  const handleClick = (lng) => {
    i18n.changeLanguage(lng);

    if (onClick) {
      onClick();
    }
  };

  // Determine alignment based on language direction
  const dropdownAlignment = i18n.dir() === 'rtl' ? 'start' : 'end';

  return (
    <Dropdown align={dropdownAlignment}>
      <Dropdown.Toggle variant="link" className={`p-0 text-decoration-none ${styles.dropdownToggle} ${styles.toggleContent}`}>
        <img src={Globe} alt='Language' className={styles.globeIcon} />
        {languages.find(lang => lang.code === i18n.language)?.flag}
      </Dropdown.Toggle>

      <Dropdown.Menu className={styles.dropdownMenu}>
        {languages.map((language) => (
          <Dropdown.Item 
            key={language.code}
            active={i18n.language === language.code}
            onClick={() => handleClick(language.code)}
            className={`${styles.menuItem} ${i18n.language === language.code ? styles.activeItem : ''}`}
          >
            <span className={styles.flag}>{language.flag}</span>
            <span className={styles.languageName}>{language.name}</span>
            {i18n.language === language.code && (
              <span className={styles.checkmark}>✓</span>
            )}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};
